import { uniqBy } from 'lodash';
import { put, takeEvery } from 'redux-saga/effects';
import { Country } from '../../../Models/Country';
import { localStorage } from '../../../lib/storages/localStorage';
import { countriesGetError, countriesGetSuccess } from './actions';
import * as TYPES from './types';
import { DEFAULT_COUNTRY_ID } from '@model/Country';

export default function* countriesSagas() {
    yield takeEvery(TYPES.COUNTRIES_GET_REQUEST, countriesGetRequest);
}

function* countriesGetRequest(action) {
    const storageKey = `${TYPES.COUNTRIES_GET_REQUEST}_v2`;

    try {
        let items;

        if (localStorage.getItem(storageKey)) {
            items = localStorage.getItem(storageKey);
        } else {
            const response = yield Country.index({
                ...action.payload,
            });

            items = uniqBy(response.data, 'id');
            const defaultCountryIndex = items.findIndex((item) => item.id === DEFAULT_COUNTRY_ID);
            const defaultCountry = items.splice(defaultCountryIndex, 1)[0];
            items.splice(0, 0, defaultCountry);
            localStorage.setItem(storageKey, items);
        }

        const data = {
            items: items,
            pagination: { total: 0, pages: 0 },
        };

        yield put(
            countriesGetSuccess({
                data,
                _params: action.payload,
            }),
        );
    } catch (error) {
        yield put(countriesGetError(error));
    }
}
